/**
 * Reset-password-complete component.
 * supplies texts for setPasswordComplete screen in reset-password scenario
 */
import SetPasswordComplete, { SetPasswordCompleteProps } from "../set-password/SetPasswordComplete";
import { baseUrl, translate } from "@kaltura/mediaspace-shared-utils";

type Props = Pick<SetPasswordCompleteProps, "qrCode">;

export function ResetPasswordComplete({ qrCode }: Props) {
    return (
        <SetPasswordComplete
            qrCode={qrCode}
            completeTitle={translate("Password Has Been Changed")}
            completeText={translate("Click below to login to the site.")}
            completeButtonTitle={translate("Login")}
            completeButtonUrl={`${baseUrl}/user/login`}
        />
    );
}

export default ResetPasswordComplete;
